import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  Input,
  Inject,
} from '@angular/core';
import { CotizadorService } from 'src/app/services/cotizador.service';
import { Subscription, Subject } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { SecurityService } from 'src/app/services/security.service';
import { StrappiService } from 'src/app/services/strappi.service';
import { ActivatedRoute } from '@angular/router';
import { SummaryService } from 'src/app/services/summary.service';
import { environment } from 'src/environments/environment';
import { KM_20 } from 'src/app/pages/buro/pages/identidad/constants';
import { WINDOW } from 'src/app/utils/window';
import { NgxTippyProps } from 'ngx-tippy-wrapper';
@Component({
  selector: 'app-deadline-table',
  templateUrl: `./deadline-table.component${environment.templateSuffix}.html`,
  styleUrls: ['./deadline-table.component.scss'],
})
export class DeadlineTableComponent implements OnInit, OnDestroy {
  @Input() isAfin: boolean = false;
  @ViewChild('containerDeadline') private containerDeadline:
    | ElementRef
    | undefined;
  @ViewChild('table') private table: ElementRef | undefined;
  deadlines: Array<any> = [];
  subscriptionDeadlines!: Subscription;
  idQuoter: any;
  selectPeriod: string = environment.templateSuffix === '' ? 'period36' : 'period24';
  selectConcept: any;
  loadingDeadline: boolean = true;
  showDeadline: boolean = true;
  subscriptionInteractionPanel!: Subscription;

  showLeasing: boolean = false;
  showRenting: boolean = false;

  screenSize = this.window.innerWidth;
  subscriptionScreen!: Subscription;
  subscriptionInteraction!: Subscription;
  isAvanced: boolean = false;
  resetInsurance: boolean = false;

  planes: any;
  destroy: Subject<boolean> = new Subject<boolean>();

  deadlineSelect: any;
  clickEventsubscription!: Subscription;
  private resDeadlines: any;

  tippyProps: NgxTippyProps = {
    trigger: 'click',
    allowHTML: true,
    animation: 'scale-extreme',
    theme: 'bitcar'
  };

  constructor(
    private cotizadorService: CotizadorService,
    private dataService: DataService,
    private securityService: SecurityService,
    private strappiService: StrappiService,
    private route: ActivatedRoute,
    public summaryService: SummaryService,
    @Inject(WINDOW) private window: Window
  ) {
    this.strappiService.getPlanPage().subscribe((res: any) => {
      if (this.isAfin)
        this.planes = {
          afin: {
            tooltip: res.plan[2].tooltip,
            video: res.plan[2].video,
          },
          rr: {
            tooltip: res.plan[2].tooltip,
            video: res.plan[2].video,
          },
        };
      else
        this.planes = {
          Leasing: {
            tooltip: res.plan[0].tooltip,
            video: res.plan[0].video,
          },
          Renting: {
            tooltip: res.plan[1].tooltip,
            video: res.plan[1].video,
          }
        };
    });

    this.clickEventsubscription = this.dataService.getSharedFunction().subscribe((data) => {
      this.resultOfRequestNotSuccess(data);
    });
  }

  ngOnInit(): void {
    this.subscriptionScreen = this.dataService
      .getScreenSize()
      .subscribe((resp) => (this.screenSize = resp));
    this.getUrlParams();


    this.dataService.getDeadlineSelect().subscribe({
      next: (deadline: object) => {
        this.deadlineSelect = deadline;
        if (deadline === undefined) {
          this.showDeadline = false;
          this.loadingDeadline = true;
          this.resetInsurance = true;
        } else {
          this.resetInsurance = false;
          this.showDeadline = true;
        }
      },
      error(err) {
        console.error(err);
      }
    });

  }

  async getUrlParams() {
    this.route.queryParams.subscribe((params) => {
      const paramsQuote = params['quote']
        ? this.securityService.decryptData(params['quote'])
        : null;
      if (paramsQuote?.deadlineConcept && paramsQuote?.dealinePeriod) {
        this.selectConcept = paramsQuote.deadlineConcept;
        this.selectPeriod = `period${paramsQuote.dealinePeriod}`;
        this.dataService.setPeriod(paramsQuote.dealinePeriod);
      }

      this.subscriptionDeadlines = this.dataService
        .getQuoterData()
        .subscribe((resDeadlines) => {
          if (resDeadlines) {
            this.resDeadlines = resDeadlines;
            this.showDeadline = this.resetInsurance ? false : true;
            this.getDeadlines(resDeadlines);
          } else {
            this.showDeadline = false;
            this.loadingDeadline = false;
          }
        });
    });
  }

  getDeadlines(request: any) {
    this.deadlines = [];
    this.loadingDeadline = true;
    this.cotizadorService.generateQuoter(request).subscribe({
      next: (res) => {
        this.typeConceptDeadLines(res, this.isAfin);
        this.loadingDeadline = false;
        this.dataService.setInteractionUserPanel(false);
      },
      error: () => {
        this.loadingDeadline = false;
        this.dataService.setInteractionUserPanel(false);
      },
    });
  }


  typeConceptDeadLines(res: any, isAfin: boolean) {
    this.idQuoter = res.id;
    if (isAfin) {

      if (res.quoterType === 'AFIN') {
        this.selectDeadline(
          res.afin.concept,
          res.afin[this.selectPeriod],
          false
        );
        let tranformAfin = this.transformArray(res.afin);
        tranformAfin = this.hasMaintenanceExpenses(tranformAfin);
        // FORD: campaign
        let colum1 = tranformAfin.slice(0, 3);
        let colum2 = tranformAfin.slice(3);
        colum2.map(item=>{
          item.comparaData = true
        });        
        colum1.push(...colum2);
        this.deadlines = [
          { title: 'afin', data: colum1, hide: false },
        ];
        this.dataService.setTenPercentPrice(res.tenPercentPrice);
        this.dataService.setAllDeadlines({ afin: res.afin });
      } else {
        this.selectDeadline(
          res.rr.concept,
          res.rr[this.selectPeriod],
          false
        );
        let tranformAfin = this.transformArray(res.rr);
        tranformAfin = this.hasMaintenanceExpenses(tranformAfin);
        let colum1 = environment.templateSuffix !== '' ? tranformAfin : tranformAfin.slice(0, 3);
        let colum2 = environment.templateSuffix !== '' ? [] : tranformAfin.slice(3);
        colum2.map(item=>{
          item.comparaData = true
        });        
        colum1.push(...colum2);
        this.deadlines = [
          { title: 'rr', data: colum1, hide: false },
        ];
        this.dataService.setTenPercentPrice(res.tenPercentPrice);
        this.dataService.setAllDeadlines({ rr: res.rr });
      }
    } else {
      this.dataService.setAllDeadlines({ leasing: res.leasing, renting: res.renting });

      this.selectDeadline(
        this.selectConcept || 'Leasing',
        !!this.selectConcept
          ? res[this.selectConcept.toLowerCase()][this.selectPeriod]
          : res.leasing[this.selectPeriod],
        false
      );
      this.deadlines = [
        {
          title: 'Leasing',
          data: this.transformArray(res.leasing),
          hide: res.leasing.hideRenting,
        },
        // TODO: REMOVIDO POR PETICIÓN
        // {
        //   title: `${environment.templateSuffix === ''
        //     ? 'Vs crédito tradicional'
        //     : 'Crédito tradicional'
        //     }`,
        //   data: this.transformArray(res.credit),
        //   hide: false,
        // },
        // {
        //   title: 'Renting',
        //   data: this.transformArray(res.renting),
        //   hide: res.renting.hideRenting,
        // },
      ];

      if (res.renting.hideRenting) {
        this.selectDeadline('Leasing', res.leasing['period36'], true);
      }

      if (res.leasing.hideRenting) {
        this.selectDeadline('Renting', res.renting['period36'], true);
      }
    }
  }

  transformArray(data: any) {
    let newArray = [];
    for (const [key, value] of Object.entries(data)) {
      if (key !== 'concept' && key !== 'hideRenting') {
        let object = {
          type: key.replace(/\D/g, ''),
          values: value,
          comparaData:false
        };
        newArray.push(object);
      }
    }
    return newArray;
  }

  async selectDeadline(concept: string, period: any, isSelected: any) {
    if (concept === 'Leasing' || concept === 'Renting' || concept === 'afin' || concept === 'rr') {
      // period.period = environment.templateSuffix === '' ? period.period : '24';
      this.dataService.setPeriod(period.period);
      this.selectConcept = concept;
      this.selectPeriod = `period${period.period}`;
      this.dataService.setDeadlineSelect({
        idQuoter: this.idQuoter,
        concept: concept,
        ...period,
        isSelected,
      });
    }
  }

  checkSelectCard(concept: string, type: any) {
    let valuePeriod = `period${type}`;

    if (this.selectConcept === 'rr') {
      return this.selectPeriod === valuePeriod;
    } else {
      return this.selectConcept === concept && this.selectPeriod === valuePeriod;
    }
  }

  ngOnDestroy(): void {
    this.deadlines = [];
    this.subscriptionDeadlines.unsubscribe();
    this.subscriptionScreen.unsubscribe();
    this.clickEventsubscription.unsubscribe();
  }

  avanzar() {
    this.isAvanced = true;
    this.table!.nativeElement.scrollTo({
      left: this.table!.nativeElement.scrollLeft + 750,
      behavior: 'smooth',
    });
  }

  retroceder() {
    this.isAvanced = false;
    this.table!.nativeElement.scrollTo({
      left: this.table!.nativeElement.scrollLeft - 750,
      behavior: 'smooth',
    });
  }

  isDisableBtn() {
    return this.isAvanced ? '' : 'disabled-btn';
  }
  isDisableBtn2() {
    return this.isAvanced ? 'disabled-btn' : '';
  }

  resultOfRequestNotSuccess(data?: boolean) {
    return data;
  }

  preauthorize() {
    this.dataService.sendSharedFunction('preauthorize');
  }

  hasMaintenanceExpenses(quoters: any[]) {
    if (KM_20 < this.dataService.getKm()) {
      return quoters.filter(quoter => {
        let { type, values } = quoter;
        if (type === '60') {
          if (values.deliveryCost.hasOwnProperty("maintenanceExpenses")) {
            return null;
          }
        }
        return quoter;
      });
    }
    return quoters;
  }

}
